module.exports = __webpack_public_path__ + "img/RBA_JEUX_VIDEO_15s.49d5e57d.jpg";